import _ from "lodash";
import BarsChartControllerBase from "./bars_chart_base_controller";
import {
  accumulateValuesFn,
  dataKeyForPayerType,
  joinNounsWithOr,
  partitionPayers,
  payersNoun,
  toOneDecimal,
  uniqPayersFromCustomFields,
} from "../../utilities/charts/chart_utils";
import showPayersModal from "../../utilities/charts/payers_modal";

export default class extends BarsChartControllerBase {
  titleText() {
    return `${this.drug} ${this.params.custom_field}`;
  }

  descriptionText(yes, all) {
    const nouns =
      this.coverageMetric === "lives"
        ? "million lives"
        : payersNoun(this.payerTypesShown).toLowerCase();

    const preposition = this.params.custom_preposition || `with ${this.numeratorText}`;

    return `There are ${toOneDecimal(yes)} ${nouns}
            ${preposition} ${this.params.custom_field}
            out of the ${toOneDecimal(all)} ${nouns}`;
  }

  currentAndPriorDataForTarget(target) {
    const { payerType } = target.dataset;
    const customFieldValues = this.params.data[this.drug][payerType];
    const priorCustomFieldValues = this.params.previous_data?.[this.drug]?.[payerType];

    const accumulate = x =>
      accumulateValuesFn(payerType, this.coverageMetric)(uniqPayersFromCustomFields(x));

    return {
      current: {
        yes: accumulate(_.pick(customFieldValues, ...this.params.numerator_values)),
        all: accumulate(customFieldValues),
      },
      prior: {
        yes: accumulate(_.pick(priorCustomFieldValues, ...this.params.numerator_values)),
        all: accumulate(priorCustomFieldValues),
      },
    };
  }

  onBarClick(event) {
    this.showPartitionModal(event, "included");
  }

  onBarRemainderClick(event) {
    this.showPartitionModal(event, "excluded");
  }

  showPartitionModal(event, side) {
    const payerType = dataKeyForPayerType($(event.target).data("payer-type"));
    const preposition = side === "included" ? "with" : "without";
    const title = `${payersNoun(payerType)} ${preposition} ${this.numeratorText} for ${this.drug} ${
      this.params.custom_field
    }`;

    const payerIds = {};
    const extraParams = {};

    const payerIdsFor = dataset => {
      const allFieldData = dataset?.[this.drug]?.[payerType] || {};

      return partitionPayers(allFieldData, Object.keys(allFieldData), this.params.numerator_values)[
        side
      ].map(p => p.payer);
    };

    if (this.showChangesFromPrevious) {
      const currentPayers = payerIdsFor(this.params.data);
      const priorPayers = payerIdsFor(this.params.previous_data);

      payerIds[payerType] = _.union(currentPayers, priorPayers);
      const changedPayers = _.xor(currentPayers, priorPayers);

      extraParams.changedCoverage = {
        [payerType]: changedPayers.map(payer => ({ payer, drug: this.drug })),
      };
      extraParams.previousSnapshotSetId = this.params.previous_snapshot_set.id;
      if (side === "excluded") {
        extraParams.changeDisplayMode = "custom_fields";
      }
    } else {
      payerIds[payerType] = payerIdsFor(this.params.data);
    }

    showPayersModal(this.drug, title, payerIds, extraParams);
  }

  get numeratorText() {
    return joinNounsWithOr(this.params.numerator_values);
  }
}
